import React, { Component } from "react";
import Loader from "./Loader";
import classNames from "classnames";
import loading_gif from "../../../images/loading.gif";
import { coins } from "../../../Utils/Constants";

const ShoppingCoin = require("../../../images/wallet/percent-coin.png");

class MessageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      user_img:
        props.user_avatar || require("../../../images/livechat/user.png"),
    };
  }

  componentDidMount() {
    const { timeoutValue, type } = this.props;
    console.log("type", type);
    setTimeout(
      () => {
        this.setState({
          loaded: true,
        });
      },
      type === "bot" ? timeoutValue : 0
    );
  }

  renderMessage() {
    const { message, style } = this.props;

    return (
      <div className={`message`} style={style}>
        <span>{message}</span>
      </div>
    );
  }
  getType(type) {
    if (type !== "user") return "bot";
    return "user";
  }
  getIcon(type) {
    const { icon } = this.props;
    if (type === "shopping_token_bot") return ShoppingCoin;
    if (type === "premier_token_bot") return coins["USA"];
    return icon;
  }
  render() {
    const {
      firstChild,
      icon,
      color,
      isLanding,
      type,
      message,
      src,
      loading,
      media_type,
      id,
      overrideText,
    } = this.props;
    const { loaded, user_img } = this.state;
    return (
      <div
        key={id}
        className={classNames({ "landing-message-item": isLanding })}
        style={
          this.getType(type) === "bot"
            ? {
                margin: 10,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
              }
            : {
                margin: 10,
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
              }
        }
      >
        {this.getType(type) === "bot" &&
          (isLanding ? (
            <div className="landing_icon" style={{ backgroundColor: color }}>
              <img
                src={icon}
                style={{
                  width: 20,
                  height: 20,
                }}
                alt="concierge"
              />
            </div>
          ) : (
            <img
              src={loading ? loading_gif : this.getIcon(type)}
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                flex: "none",
              }}
              alt="concierge"
              className="avatar"
            />
          ))}

        {src && (
          <div
            className={`message-item-wrapper ${
              loaded ? "loaded" : ""
            } ${this.getType(type)} ${firstChild ? "first-child" : ""}`}
            style={{
              width: "100%",
              marginTop: 0,
              marginBottom: 0,
            }}
          >
            <Loader />

            <div
              className="message"
              style={{
                backgroundImage: `url(${src})`,
                width: "100%",
                height: 200,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            />
          </div>
        )}
        {message && (
          <div
            className={`message-item-wrapper ${
              loaded ? "loaded" : ""
            } ${this.getType(type)} ${firstChild ? "first-child" : ""}`}
            style={{ marginTop: 0, marginBottom: 0 }}
          >
            <Loader />

            {this.renderMessage(this.props.message)}
          </div>
        )}

        {this.getType(type) === "user" && (
          <div
            className="avatar"
            style={{ backgroundImage: `url(${user_img})` }}
            alt="concierge"
          />
        )}
      </div>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./src/screens/Profile/components/MessageItem.js